<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：分类管理
    -->
  <div class="company">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="分类名称">
          <el-input size="small" v-model="searchForm.category_name" placeholder="分类名称">
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
       </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="company-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="分类名称"></el-table-column>
            <el-table-column prop="count" label="企业数量"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
        <span style="display: block;margin-top: 8px;font-size: 15px;">企业总数量：{{ count }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import CompanyApi from '@/api/company.js';
  export default {
    components: {
    },
    data() {
      return {
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        searchForm:{
          category_name:""
        },
        form: {},
        count:0,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params = this.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;  
        CompanyApi.statisticList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.count = data.data.count;
            console.log(data,'11111')
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/company/statistic.vue